import {useLocation} from "react-router-dom";
import {useTranslation, withTranslation} from "react-i18next";
import {useEffect, useState} from "react";
import _ from "lodash";
import {Timeline} from "antd";

function Tek3Eso(props) {
    const {t, i18n} = useTranslation();
    const [timelineData, setTimelineData] = useState([]);

    const {query, search} = useLocation();
    const year = +new URLSearchParams(search).get('year');

    const getPoints = (code) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });
        if (mResult && mResult[0]) {
            if (mResult[0].points === 999) {
                return 999;
            }

        }

        return 0;
    }
    const getResponse = (code) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });

        if (mResult && mResult[0]) {
            if (mResult[0].assessment.questionType === "MULTIPLE3" || mResult[0].assessment.questionType === "MULTIPLE2" || mResult[0].assessment.questionType === "MULTIPLE4") {
                let mText = mResult[0].subanswers.map(sub => sub.response.question).join(', ')

                return mText

            } else {
                if (mResult[0].response) {
                    return mResult[0]?.response?.question
                } else {
                    if (mResult[0].degree) {
                        return mResult[0]?.degree?.title
                    }else{
                        if (mResult[0].subject) {
                            return mResult[0]?.subject?.subject
                        }
                    }
                }
            }
        } else {
            return "";
        }
    }


    const getResponseModality = (code) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });

        if (mResult && mResult[0]) {

            return mResult[0]?.subject?.modality


        } else {
            return "";
        }
    }

    const getResponseSubject = (code, pos) => {
        let mResult = _.filter(props.answers, function (o) {
            return o.assessment && o.assessment.order === code
        });

        if (mResult && mResult[0]) {
            if (pos === 0) {
                return mResult[0]?.subject?.subject
            }
            let order = _.orderBy(mResult[0]?.subanswers, ["subject.order"], ['asc']);

            if (pos === 1) {
                return order[0]?.subject?.subject + ", " + order[1]?.subject?.subject
            }
            if (pos === 2) {
                return order[2]?.subject?.subject
            }
        } else {
            return "";
        }
    }

    useEffect(() => {
        let mTimeline =
            [
                {
                    color: '#20388F',
                    date: '20' + year + ' - 20' + (year + 1),
                    message: '<strong>' + t("tengo") + '</strong>: ' + getResponse(2) + '<br />'
                        + '<strong>' + t("tek.duranteeste") + '</strong>: ' + getResponse(3) + '<br /><br />'
                },
                {
                    color: '#52C41A',
                    date: '20' + (year + 1) + ' - 20' + (year + 2),
                    message: '<strong>' + t("tek.pienso4") + '</strong>: ' + getResponse(4) + '<br />'
                        + '<strong>' + t("tek.mismaterias4") + '</strong>: ' +
                                (year < 23 ?  getResponse(12)  : (getResponse(12) + '<br />' + getResponse(13))+ '<br />') + '<br />'
                        + '<strong>' + t("tek.mismaterias42") + '</strong>: ' + (year < 23 ?  getResponse(13) : getResponse(14) + '<br />')+ '<br />'
                    + (getPoints(5) !== 999 ? '<strong>' + t("tek.mcfb") + '</strong>: ' + getResponse(5) + '<br /><br />' : '<br />')

                },
                {
                    color: '#F5222D',
                    date: '20' + (year + 2) + ' - 20' + (year + 3),
                    message: '<strong>' + t("tek.graduado") + '</strong>: ' + getResponse(7) + '<br />'
                        + (getPoints(8) !== 999 ? '<strong>' + t("tek.mcfm") + '</strong>: ' + getResponse(8) + '<br /><br />' : '<br />')
                        + '<strong>' + t("tek.mbtx") + '</strong>: ' + getResponse(10) + '<br />'
                        +(getPoints(5) !== 999 ? '<strong>' + t("tek.encasocfgbb") + '</strong>: ' + getResponse(6) + '<br />' : '<br />')
                },
                {
                    color: '#20388F',
                    date: '20' + (year + 3) + ' - 20' + (year + 4),
                    message: (getPoints(8) !== 999 ? '<strong>' + t("tek.segundog") + '</strong><br />' : '<br />')
                    +(getPoints(10) !== 999 ? '<strong>' + t("tek.segundob") + '</strong><br />' : '<br />')

                },
                {
                    color: '#6882DE',
                    date: '20' + (year + 4) + ' - 20' + (year + 5),
                    message: (getPoints(8) !== 999 ? '<strong>' + t("tek.encasocfgm") + '</strong>: ' + getResponse(9) + '<br />' : '<br />')
                        +(getPoints(11) !== 999 ? '<strong>' + t("tek.encasobacn") + '</strong>: ' + getResponse(11) + '<br />' : '<br />')

                        +(getPoints(14) !== 999 ? '<strong>' + t("tek.miunist") + '</strong>: ' +  (year < 23 ? getResponse(14) : getResponse(15) )+ '<br />' : '<br />')                }
            ];
        props.setTimeline(mTimeline)
        setTimelineData(mTimeline)
    }, [year])

    return (
        <>
            {!props.forDownload &&
            <Timeline mode={'left'}>
                {timelineData.map(item => <Timeline.Item color={item.color} key={item.date} label={item.date}>
                        <p dangerouslySetInnerHTML={{__html: item.message}}/>
                    </Timeline.Item>
                )}
            </Timeline>}
        </>
    );
}

export default withTranslation()(Tek3Eso);
